import { t } from "@/i18n-js/instance";
import { Avatar } from "@circle-react/components/SettingsApp/Workflows/components/Avatar";
import { Typography } from "@circle-react-uikit/Typography";
import { MemberTagFromId } from "./MemberTagById";

export interface HistoryDetailViewTagProps {
  body: {
    member_tag_id: number;
    community_member_id: number;
    contact_id: number;
  };
}

export const HistoryDetailViewTag = ({ body }: HistoryDetailViewTagProps) => {
  const {
    member_tag_id: memberTagId,
    community_member_id: communityMemberId,
    contact_id: contactId,
  } = body;

  return (
    <>
      <div className="md:flex">
        <div className="w-1/4">
          <Typography.LabelSm weight="semibold">
            {t("settings.workflows.action_messages.tag")}
          </Typography.LabelSm>
        </div>
        <div className="w-3/4">
          <MemberTagFromId memberTagId={memberTagId} />
        </div>
      </div>
      <div className="md:flex">
        <div className="w-1/4">
          <Typography.LabelSm weight="semibold">
            {t("settings.workflows.action_messages.member")}
          </Typography.LabelSm>
        </div>
        <div className="w-3/4">
          <Avatar communityMemberId={communityMemberId || contactId} />
        </div>
      </div>
    </>
  );
};
